import {Card, Carousel, Divider, Row, Tag, Typography} from "antd";
import { styled } from "styled-components";

export const StyledDivider = styled(Divider)`
margin: 14px 0 8px 0;
`;
export const StyledAlertMessageCard = styled(Card)`
    margin: 1rem 0;
    background-color: rgb(255, 245, 245);
border-color: 1px solid rgb(255, 204, 204)
border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: right;
    align-items: center;
    text-align: right;
    font-size: .6rem;
    color: rgba(255, 82, 82, 1);
    font-weight: bold;

    .ant-card-body {
        padding: 14px;
    }
`;
export const StyledTypography = styled(Typography)`
    span{
        color: #0a53be;
    }
`;
export const StyledCategoryTag = styled(Tag)`
   color: white;
    background-color: var(--thirdColor);
    cursor: pointer;
    font-size: .5rem;
    font-weight: bolder;
`;
export const StyledCarousel = styled(Carousel)`

    .slick-dots {
         flex-direction: row !important; 
    }
`;
